import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { categoryApi } from '../../services/category';

interface CategoryState {
  selectedCategory: any | null;
  filters: {
    sortBy: string | null;
    sortOrder: 'asc' | 'desc';
  };
  pagination: {
    page: number;
    limit: number;
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: CategoryState = {
  selectedCategory: null,
  filters: {
    sortBy: null,
    sortOrder: 'desc',
  },
  pagination: {
    page: 1,
    limit: 10,
  },
  isLoading: false,
  error: null,
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setSelectedCategory: (state, action: PayloadAction<any | null>) => {
      state.selectedCategory = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<CategoryState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.page = 1;
    },
    setPagination: (state, action: PayloadAction<Partial<CategoryState['pagination']>>) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearCategory: (state) => {
      state.selectedCategory = null;
      state.error = null;
    },
    resetFilters: (state) => {
      state.filters = {
        sortBy: null,
        sortOrder: 'desc',
      };
      state.pagination.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        categoryApi.endpoints.getCategories.matchPending,
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        categoryApi.endpoints.getCategories.matchFulfilled,
        (state) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        categoryApi.endpoints.getCategories.matchRejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.error.message || 'Помилка завантаження категорій';
        }
      );
  },
});

export const {
  setSelectedCategory,
  setFilters,
  setPagination,
  setLoading,
  setError,
  clearCategory,
  resetFilters,
} = categorySlice.actions;

export default categorySlice.reducer; 